import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { Icon } from '@deity-io/portal-ui';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGetPackageVersionQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';
import { isPackageEditable } from 'utils/is-package-editable';

type EntityWrapperProps = {
  title: string;
  button: JSX.Element;
};
export const EntityWrapper: FC<EntityWrapperProps> = ({ title, button, children }) => {
  const { pathname } = useLocation();
  const pathArr = pathname.split('/');
  pathArr.pop();

  const params = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);

  const { data } = useGetPackageVersionQuery({
    variables: {
      uuid: params?.versionUuid
    },
    skip: !params?.versionUuid,
    ...CACHE_FIRST
  });

  const isEditable: boolean = data?.getPackageVersion.status
    ? isPackageEditable(data?.getPackageVersion.status)
    : false;

  return (
    <>
      <FlexLayout alignItems="center" justifyContent="space-between" pb="xl">
        <FlexLayout alignItems="center">
          <Link to={`${pathArr.join('/')}/package`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <H4 fontSize="xl" fontWeight="semiBold">
              Package
            </H4>
          </Link>
          <Icon icon="chevronRight" sx={{ margin: '0 5px' }} />
          <H4 fontSize="xl" fontWeight="semiBold">
            {title}
          </H4>
        </FlexLayout>
        {isEditable && button}
      </FlexLayout>
      <Box
        border="regular"
        borderColor="borderLight"
        borderRadius="small"
        pb="lg"
        pt="md"
        bg="white"
        boxShadow="subtle"
      >
        {children}
      </Box>
    </>
  );
};
